<template>
	<span @click="show($event)">
		<slot></slot>
	</span>
</template>
<script>
	export default {
		props: {
			title: String,
			iframe: String
		},

		data() {
			return {
				shown: false
			};
		},

		computed: {
			$modal() {
				return $('#main-modal');
			}
		},

		methods: {
			show(ev) {
				if (ev) {
					ev.preventDefault();
				}
				this.appendToModal();
				this.$modal.modal('show');
			},

			appendToModal() {
				this.$modal.find('.modal-content').html(`
					<div class="modal-header">
						<div class="h5 modal-title">${this.title}</div>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
					</div>
		            <div class="modal-body">
		            	<div class="embed-responsive embed-responsive-16by9">${this.iframe}</div>
					</div>
				`)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/YoutubeLink.vue